import React from 'react'

const CMinbox = () => {
  return (
    <div>CMinbox</div>
  )
}

export default CMinbox